$(document).ready(function(){
// search autocomplete
    var client = algoliasearch(process.env.MIX_ALGOLIA_APP_ID, process.env.MIX_ALGOLIA_SEARCH);
    var index = client.initIndex(process.env.MIX_ALGOLIA_INDEX_NAME_CADDICK);
    $('#search-input-autocomplete, #error-search-input-autocomplete').autocomplete(
        { hint: false }, [{
            source: $.fn.autocomplete.sources.hits(index, { hitsPerPage: 5 }),
            displayKey: 'articleName',
            templates: {
                suggestion: function(suggestion) {
                    return '<div class="autocomplete-search-result">' +
                        '<a href="/product/' + suggestion.slug + '">' +
                            '<span class="autocomplete-search-result-name">' + suggestion._highlightResult.articleName.value + '</span>' +
                            '<span class="autocomplete-search-result-id">' + suggestion._highlightResult.ownArticleNumber.value + '</span>' +
                            '<span class="autocomplete-search-result-price">&pound;' + suggestion._highlightResult.fromPrice.value + '</span>' +
                            '<span class="autocomplete-search-result-vatprice">&pound;' + suggestion._highlightResult.vatFromPrice.value + '</span>' +
                        '</a>' +
                    '</div>';
                },
                empty: function(options) {
                    return '<div class="autocomplete-no-results">No products found</div>';
                }
            }
        }
    ]).on('autocomplete:selected', function(event, suggestion, dataset) {
        console.log(suggestion, dataset);
    });

});

/*$(document).ready(function () {
    const $dropdown = $('#user-dispatch-address');

    if ($dropdown.length) {
        $dropdown.on('change', function () {
            const selectedValue = $(this).val();

            if (selectedValue && selectedValue.length > 0) {
                const $addressContainer = $(this).closest('.form-group-user-address').nextAll('.address-fields').first();

                if ($addressContainer.length) {
                    if (typeof niceAddress === 'function') {
                        niceAddress($addressContainer);
                    } else {
                        console.warn('niceAddress is not defined.');
                    }

                    $addressContainer.siblings('.address-block').slideDown();
                    $addressContainer.siblings('.invoice-address-checkbox, .recipient-name').slideDown();
                    $addressContainer.siblings('.form-group-address-dropdown, .non-uk-address').slideUp();
                } else {
                    console.warn('No .address-fields found near the dropdown.');
                }
            }
        });
    } else {
        console.warn('#user-dispatch-address not found in DOM.');
    }
    if (!$('#enquiry-delivery-info').length) {
        $('body').append('<div id="enquiry-delivery-info" style="display: none;"><input type="hidden" value="" /></div>');
    }

    if (typeof niceAddress !== 'function') {
        window.niceAddress = function () {
            console.warn('niceAddress() fallback used.');
        };
    }

    $dropdown.on('change', function () {
        const selectedValue = $(this).val();

        if (!selectedValue) return;

        const $addressContainer = $(this).closest('.form-group-user-address').nextAll('.address-fields').first();

        if ($addressContainer.length) {
            // Try niceAddress if available
            if (typeof niceAddress === 'function') {
                niceAddress($addressContainer);
            } else {
                // fallback manual population
                console.warn('niceAddress is not defined. Using fallback.');
                populateAddressManually(selectedValue, $addressContainer);
            }

            $addressContainer.siblings('.address-block').slideDown();
            $addressContainer.siblings('.invoice-address-checkbox, .recipient-name').slideDown();
            $addressContainer.siblings('.form-group-address-dropdown, .non-uk-address').slideUp();
        } else {
            console.warn('No .address-fields found near the dropdown.');
        }
    });

// Fallback function if niceAddress is missing
    function populateAddressManually(id, container) {
        $.ajax({
            url: '/get-address-by-id/' + id, // Create this route in Laravel
            method: 'GET',
            success: function (response) {
                container.find('#dispatch-line1').val(response.line1);
                container.find('#dispatch-line2').val(response.line2);
                container.find('#dispatch-city').val(response.city);
                container.find('#dispatch-postcode').val(response.postcode);
                container.find('#dispatch-companyname').val(response.companyname);
                container.find('#dispatch-firstname').val(response.firstname);
                container.find('#dispatch-lastname').val(response.lastname);
                container.find('#dispatch-country').val(response.country);
            },
            error: function () {
                console.error('Failed to fetch address data.');
            }
        });
    }
});
*/